import React, { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import './AcceptStyle.css'
import SMSIcon from '../../icons/SMSIcon'

export const AcceptSMScomponent = () => {
  const navigate = useNavigate()
  const [activationStatus, setActivationStatus] = useState('')
  const [authCode, setAuthCode] = useState(Array(6).fill(''))
  const [resendStatus, setResendStatus] = useState('')
  const inputRefs = useRef([])

  const handleInputChange = (index, value) => {
    if (/^[0-9]?$/.test(value)) {
      const newAuthCode = [...authCode]
      newAuthCode[index] = value
      setAuthCode(newAuthCode)

      if (value !== '' && index < newAuthCode.length - 1) {
        inputRefs.current[index + 1].focus()
      }
    }
  }

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && authCode[index] === '' && index > 0) {
      const newAuthCode = [...authCode]
      newAuthCode[index - 1] = ''
      setAuthCode(newAuthCode)
      inputRefs.current[index - 1].focus()
      // Предотвращаем стандартное действие, чтобы не удалять лишнее
      e.preventDefault()
    }
  }

  const handleActivation = async () => {
    try {
      const phone = window.location.pathname.split('/accept/')[1]
      const requestData = {
        phone: `${phone}`,
        auth_code: authCode.join('')
      }

      const response = await axios.post(process.env.REACT_APP_API_URL + '/loyalty/activate-user', requestData, {
        headers: { 'Content-Type': 'application/json' }
      })

      if (response.data.status === 1) {
        console.log('Sukces:', response.data)
        setActivationStatus('Sukces.')
        navigate('/login')
      } else {
        console.error('Error:', response.data)
        setActivationStatus('Wpowadzony kod jest błędny')
      }
    } catch (error) {
      console.error('Ошибка при активации пользователя:', error)
      setActivationStatus('Nie dało się aktywować użytkownika')
    }
  }

  const handleResendCode = async () => {
    try {
      const phone = window.location.pathname.split('/accept/')[1]
      const requestData = { phone: `${phone}` }

      const response = await axios.post(process.env.REACT_APP_API_URL + '/loyalty/resend-code', requestData, {
        headers: { 'Content-Type': 'application/json' }
      })

      if (response.data.status === 1) {
        console.log('Код повторно отправлен:', response.data)
        setResendStatus('Kod wysłano jeszcze raz')
      } else {
        console.error('Ошибка при повторной отправке кода:', response.data)
        setResendStatus('Nie ma polączenia')
      }
    } catch (error) {
      console.error('Ошибка при повторной отправке кода:', error)
      setResendStatus('Nie ma polączenia')
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '160px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <SMSIcon />
        <p style={{ fontFamily: 'Poppins', fontSize: '28px', fontWeight: '600', textAlign: 'center' }}>Weryfikacja</p>
        <p style={{ fontFamily: 'Poppins', fontSize: '13px', fontWeight: '600', textAlign: 'center' }}>
          Wpisz kod otrzymany za pomocą SMS:
        </p>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '20px', width: '70%' }}>
        {authCode.map((value, index) => (
          <input
            key={index}
            ref={el => (inputRefs.current[index] = el)}
            id={`code-input-${index}`}
            type='text'
            value={value}
            onChange={e => handleInputChange(index, e.target.value)}
            onKeyDown={e => handleKeyDown(e, index)}
            style={{
              width: '30px',
              height: '40px',
              margin: '2px',
              borderRadius: '7px',
              border: `1.5px solid ${
                authCode.every(item => item !== '') ? 'rgba(0, 163, 255, 0.43)' : 'rgba(0, 163, 255, 0.43)'
              }`
            }}
            maxLength={1}
            inputMode='numeric'
          />
        ))}
      </div>
      <button onClick={handleActivation} className='knopka'>
        Potwierdż
      </button>
      <button onClick={handleResendCode} className='resend'>
        Wyślij kod ponownie
      </button>
      <p>{activationStatus}</p>
      <p>{resendStatus}</p>
    </div>
  )
}
